/** 
 * custom JS scripts for NBG sites
 *
 * Author: Patrick Gephart
 * URL: http://patrickgephart.com/
 * Email: pmgephart@gmail.com
 *
 * NBG Customization
 */

var toggleLinks = document.getElementsByClassName('toggle-link');

for(var i = 0; i < toggleLinks.length; i++) {
  toggleLinks[i].addEventListener('click', event => {
    event.preventDefault();

    if(this.hash) {
      var target = document.querySelector(this.hash);

      if(target.style.display == 'block') {
        target.style.display = 'none';	
      }
      else {
        target.style.display = 'block';
      }
    }
  });
}

/**
 * add shipping options to cart functionality
 */
if(document.getElementById('add-shipping-options') !== null) {
  document.getElementById('add-shipping-options').addEventListener('click', function() {
    var shippingOptions = document.getElementsByClassName('shipping-options');
    var items = [];

    for(var i = 0; i < shippingOptions.length; i++) {
      if(shippingOptions[i].checked) {
        items.push({
          id: shippingOptions[i].value,
          quantity: 1
        }); 
      }
    }

    if(items.length) {
      var xmlHttp = new XMLHttpRequest();
      var data = {items: items};

      xmlHttp.onreadystatechange = function() {
        if(this.readyState == 4 && this.status == 200) {
          location.href = "/cart";
        }
      };

      xmlHttp.open('POST', window.Shopify.routes.root + 'cart/add.js');
      xmlHttp.setRequestHeader('Content-Type', 'application/json');
      xmlHttp.send(JSON.stringify(data));
    }

    return false;
  });
}

/**
 * Judge.me review content reorder
 */
let judgeMeReviewsReorderded = false;

window.onload = function(e) {
  let reviews = document.getElementsByClassName('jdgm-rev__content');

  if(reviews !== null) {
    if(!judgeMeReviewsReorderded) {
      for(let i = 0; i < reviews.length; i++) {
        let customForm = reviews[i].querySelector('.jdgm-rev__custom-form');
        let reviewBody = reviews[i].querySelector('.jdgm-rev__pics');
        
        if(customForm !== null && reviewBody !== null) {
          customForm.remove();
          reviews[i].insertBefore(customForm, reviewBody);
        }
      }
      
      judgeMeReviewsReorderded = true;
    }
  }
};